exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{margin:0;padding:0;min-height:100vh}body{background-color:#111;color:#fff}*,body{font-family:Roboto Condensed,sans-serif}.spotify{background-color:#2ebd59;padding:1px;display:table;width:inherit;height:inherit;height:100vh;width:100%;transition:height .6s ease-out}.spotify__container{display:table-cell;vertical-align:middle}.spotify__text{max-width:600px;width:100%;text-align:center;margin:0 auto;padding:40px}.spotify h3{border-bottom:4px solid;padding:0 0 20px;margin:0 0 40px;font-weight:400;line-height:1.5}.spotify.is-selected{height:220px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-a9552a76!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Spotify.vue
// module id = 47
// module chunks = 0